// import { API_CONFIG } from '../../config'

let API_CONFIG = { baseUrl: window.appUrl.ELN }
export const sendRasaMessage = async ({ message, image, filename }) => {
    try {
        console.log('selectedFilename', filename)
        let imageData = null;

        if (image) {
            console.log("image received==============================");
            const toBase64 = (file) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result.split(",")[1]);
                    reader.onerror = reject;
                });

            imageData = await toBase64(image);
        }

        const payload = {
            sender: "user",
            message: message || "",
            metadata: {
                image_data: imageData,
                ...(filename && { filename }),
                token: sessionStorage.Token,
                "X-TenantID": sessionStorage.tenantid,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };

        const response = await fetch("http://localhost:5005/webhooks/rest/webhook", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error("Failed to communicate with Rasa server");
        }

        const data = await response.json();
        const firstResponse = Array.isArray(data) && data.length > 0 ? data[0] : {};

        return {
            botReply: firstResponse.text || "",
            aisearch_data: firstResponse.custom?.aisearch_data || null,
            aiscreen_data: firstResponse.custom?.aiscreen_data || null,
            aimultiscreen_data: firstResponse.custom?.aimultiscreen_data || null,
            aimultioption_data: firstResponse.custom?.custom?.aimultioption_data || null,
            aiimage_data: firstResponse.custom?.aiimage_data || null,
            aispread_data: firstResponse.custom?.aispread_data || null,
            image_data: firstResponse.custom?.image_data || null,
            aipage_data: firstResponse.custom?.pdf_data || null,
        };
    } catch (error) {
        console.error("Rasa API Error:", error.message);
        return {
            botReply: "Something went wrong. Please try again later.",
            aisearch_data: null,
            aiscreen_data: null,
            aimultiscreen_data: null,
            aimultioption_data: null,
            image_data: null,
            aiimage_data: null,
            aispread_data: null,
            aipage_data: null,
        };
    }
};


export const getAllGridData = async () => {
    try {
        const response = await fetch(`${API_CONFIG.baseUrl}/api/chatdocuments/all`);
        const data = await response.json();
        return { data };
    } catch (error) {
        console.error("Error fetching documents:", error);
    }
}
export const downloadByName = async ({ documentName }) => {
    try {
        const response = await fetch(`${API_CONFIG.baseUrl}/api/chatdocuments/getDocumentByNameDownload?documentName=${encodeURIComponent(documentName)}`, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error('Failed to download');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        const disposition = response.headers.get('Content-Disposition');
        const fileName = disposition?.split('filename=')[1] || documentName;

        a.href = url;
        a.download = fileName.replace(/['"]/g, '');
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Download error:', error);
        alert('Download failed');
    }
}
export const uploadDocument = async (formData) => {
    try {
        const response = await fetch(`${API_CONFIG.baseUrl}/api/chatdocuments/upload`, {
            method: "POST",
            body: formData,
        });

        const result = await response.text();
        return result;
    } catch (error) {
        console.error("Error uploading documents:", error);
        throw error;
    }
};

export const uploadContentDoc = async (formData) => {
    try {
        const response = await fetch(`${API_CONFIG.baseUrl}/api/folders/uploadMultipleFiles`, {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText);
        }

        return await response.json();
    } catch (error) {
        console.error("Error uploading documents:", error);
        throw error;
    }
};

export const fetchAllDocuments = async () => {
    try {
        const response = await fetch(`${API_CONFIG.baseUrl}/api/folders/getfiles`);

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Server error: ${errorText}`);
        }

        const data = await response.json();

        if (Array.isArray(data)) {
            // If you only want the "name" field
            return data.map(doc => doc.name);
            // Or if you need fullPath:
            // return data.map(doc => doc.fullPath);
        } else {
            console.error("Unexpected response structure:", data);
            return [];
        }
    } catch (error) {
        console.error("Failed to fetch documents:", error);
        throw error;
    }
};


